export default __webpack_public_path__ + "static/media/p2-9.667a3595.png";